import { useResilientQuery } from '@famly/stat_apollo-query';
/**
 * Extends the useResilientQuery hook with a transform function, similar to the `props`
 * argument for the equivalent `graphql` react-apolle HoC
 *
 * Usage
 * ```
 * const [{foo}, {data, loading}] = useResilientQuery<MyQuery>()(MyQuery, {}, props => ({
 *   foo: props.data?.bar + 2 ?? 'wizbiz',
 * }))
 * ```
 */
export const useTransformQuery = () => (query, options = {}, transform) => {
    const props = useResilientQuery(query, options);
    return [transform(props), props];
};
